import * as React from "react";
import { toastr } from "react-redux-toastr";
import { useDataLoader, usePerformAction } from "react-remote-data-hooks";
import api from "../../../../api";
import classnames from "classnames";
import CreateForm from "./CreateForm";
import {
  AppPermissions,
  useHasPermission,
  Dict,
  Settings,
} from "../../../../core";

export interface IEntity {
  key: string;
  label: string;
  vg?: IEntityVisibility[];
}

export interface IEntityVisibility {
  key: string;
  label: string;
  value?: string[];
}

const VGOfOnlineUnassignedEntities: React.FunctionComponent = () => {
  const [entities, setEntities] = React.useState<IEntity[]>([
    {
      key: "lead",
      label: "Lead / Opportunities",
      vg: [
        {
          key: "salesPerson",
          label: "Transaction Manager Visibility Group",
          value: [] as string[],
        },
        {
          key: "crmAgent",
          label: "Support Executive Visibility Group",
          value: [] as string[],
        },
      ],
    },
    // {
    //   key: "proposal",
    //   label: "Proposal / Agreement",
    //   vg: [
    //     {
    //       key: "salesPerson",
    //       label: "Transaction Manager Visibility Group",
    //       value: [] as string[],
    //     },
    //     {
    //       key: "crmAgent",
    //       label: "Support Executive Visibility Group",
    //       value: [] as string[],
    //     },
    //   ],
    // },
    // {
    //   key: "requirement",
    //   label: "Requirement",
    //   vg: [
    //     {
    //       key: "salesPerson",
    //       label: "Transaction Manager Visibility Group",
    //       value: [] as string[],
    //     },
    //     {
    //       key: "crmAgent",
    //       label: "Support Executive Visibility Group",
    //       value: [] as string[],
    //     },
    //   ],
    // },
    {
      key: "activity",
      label: "Activities",
      vg: [
        {
          key: "salesPerson",
          label: "Transaction Manager Visibility Group",
          value: [] as string[],
        },
        {
          key: "crmAgent",
          label: "Support Executive Visibility Group",
          value: [] as string[],
        },
      ],
    },
    {
      key: "organization",
      label: "Company",
      vg: [
        {
          key: "salesPerson",
          label: "Transaction Manager Visibility Group",
          value: [] as string[],
        },
        {
          key: "crmAgent",
          label: "Support Executive Visibility Group",
          value: [] as string[],
        },
      ],
    },
    {
      key: "customer",
      label: "Customers",
      vg: [
        {
          key: "salesPerson",
          label: "Transaction Manager Visibility Group",
          value: [] as string[],
        },
        {
          key: "crmAgent",
          label: "Support Executive Visibility Group",
          value: [] as string[],
        },
      ],
    },
    // {
    //   key: "report",
    //   label: "Reports",
    //   vg: [
    //     {
    //       key: "salesPerson",
    //       label: "Transaction Manager Visibility Group",
    //       value: [] as string[],
    //     },
    //     {
    //       key: "crmAgent",
    //       label: "Support Executive Visibility Group",
    //       value: [] as string[],
    //     },
    //   ],
    // },
  ]);

  const canCreateVisiblityGroup = useHasPermission(
    AppPermissions.CreateVisiblityGroup
  );

  const [editModal, setEditModal] = React.useState<{
    isOpen?: boolean;
    entity?: IEntity;
  }>({});

  const { data: settings, reload } = useDataLoader<Settings>(() =>
    api.settings.getSettings()
  );

  React.useEffect(() => {
    if (settings?.ownerForUnassignedEntities) {
      const entity = entities ? [...entities] : [];

      setEntities(
        entity?.map((x) => {
          return {
            ...x,
            vg: x.vg?.map((g) => {
              return {
                ...g,
                value:
                  (settings?.ownerForUnassignedEntities as any)?.[x.key]?.[
                    g.key
                  ] || [],
              };
            }),
          };
        })
      );
    }
  }, [settings?.ownerForUnassignedEntities]);

  const {
    performAction: createVisibilityGroup,
    isPerforming: isCreating,
  } = usePerformAction(
    (q: Dict) => {
      return api.settings.updateOwnerForUnassignedEntities(q);
    },
    () => {
      reload();
      setEditModal({});
      toastr.success("Success", "Updated successfully");
    },
    () => {
      toastr.error("Error", "Failed to update");
    }
  );

  const update = (group?: IEntity) => {
    const initialValue = {};
    const updateData = {
      entity: group?.key,
      visibilityGroups: group?.vg?.reduce(
        (vgObj: any, vgItem: IEntityVisibility) => {
          return {
            ...vgObj,
            [vgItem.key]: vgItem.value,
          };
        },
        initialValue
      ),
    };

    const entity = entities ? [...entities] : [];

    setEntities(
      entity?.map((x) => {
        return {
          ...x,
          vg: x.key === group?.key ? group.vg : x.vg,
        };
      })
    );

    setEntities(entity);

    createVisibilityGroup(updateData);
  };

  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 border-right">
        <div className="d-flex align-items-center py-3">
          <div className="col-auto">
            <h4 className="mb-0 font-weight-semibold">
              Owner Unassigned Entities
            </h4>
          </div>
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                <th>
                  <span className="d-inline-flex align-items-center">Name</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {entities.map((item) => {
                const haveSalesPerson = !!item?.vg?.find(
                  (x) => x.key === "salesPerson"
                )?.value?.length;

                const haveCrmAgent = !!item?.vg?.find(
                  (x) => x.key === "crmAgent"
                )?.value?.length;
                return (
                  <tr
                    key="1"
                    onClick={() => {
                      if (canCreateVisiblityGroup) {
                        setEditModal({
                          isOpen: true,
                          entity: item,
                        });
                      }
                    }}
                    className={classnames({
                      "cursor-pointer": true,
                      "text-blue": editModal?.entity?.key === item?.key,
                    })}
                  >
                    <td className="font-normal py-3">
                      {item.label}
                      <span
                        className={classnames({
                          dot: true,
                          "dot--green": haveSalesPerson && haveCrmAgent,
                          "dot--red": !(haveSalesPerson && haveCrmAgent),
                        })}
                      ></span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-lg col-md-6 col-12 p-2 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
        {editModal.isOpen && (
          <>
            <div className="text-right d-md-none">
              <i className="icon-close"></i>
            </div>
            <CreateForm
              key={"OwnerUnassignedEntitiesEdit"}
              onSubmit={update}
              isSubmitting={isCreating}
              entity={editModal.entity}
              onCancel={() => setEditModal({})}
            ></CreateForm>
          </>
        )}
      </div>
    </>
  );
};

export default VGOfOnlineUnassignedEntities;
